module.exports = __webpack_public_path__ + "img/terms.bbd58ba5.svg";